export const GET_ALL_SOCIALS_PENDING = 'GET_ALL_SOCIALS_PENDING';
export const SOCIALS_INFO = 'SOCIALS_INFO';
